const IS_OIDC_SESSION = 'is_oidc_session';
const ISI_SESSION_ID = 'isi_session_id';
const OIDC_POST_LOGIN_REDIRECT = 'oidc_post_login_redirect';

export const setIsOidcSession = () => localStorage.setItem(IS_OIDC_SESSION, 'true');
export const clearIsOidcSession = () => localStorage.removeItem(IS_OIDC_SESSION);
export const isOidcSession = () => localStorage.getItem(IS_OIDC_SESSION) === 'true';

export const getIsiSessionId = () => localStorage.getItem(ISI_SESSION_ID);
export const setIsiSessionId = (id: string) => localStorage.setItem(ISI_SESSION_ID, id);
export const clearIsiSessionId = () => localStorage.removeItem(ISI_SESSION_ID);

export const setOidcPostLoginRedirect = (path: string) => sessionStorage.setItem(OIDC_POST_LOGIN_REDIRECT, path);

export const consumeOidcPostLoginRedirect = (): string | null => {
  const path = sessionStorage.getItem(OIDC_POST_LOGIN_REDIRECT);
  sessionStorage.removeItem(OIDC_POST_LOGIN_REDIRECT);
  return path;
};
